import Vue from 'vue';
import Vuex from 'vuex';
import Language from '../enums/Language';

Vue.use(Vuex)

const DEFAULT_DISMISS_TIME_ALERT = 5;

let savedLanguage = localStorage.getItem('language');
savedLanguage = savedLanguage ? JSON.parse(savedLanguage) : undefined;

export default new Vuex.Store({
  state: {
    language: savedLanguage || Language.ENGLISH,
    show: {
      loading: false
    },
    ref: {
      loading: {
        count: 0
      }
    },
    alert: {
      show: false,
      message: '',
      messageHtml: '',
      style: '',
      code: 0,
      closeOnChangeRoute: false,
      dismissible: true
    },
  },
  getters: {
    isAuthenticated: () => !!window.localStorage.getItem('token'),
    loadingValue: state => state.show.loading,
    showAlert: state => state.alert.show,
    alertMessage: state => state.alert.message,
    alertHtml: state => state.alert.messageHtml,
    alertStyle: state => state.alert.style,
    alertDismissible: state => state.alert.dismissible
  },
  mutations: {
    language: (state, language) => state.language = language,
    event: (state, event) => state.event = event,
    options: (state, options) => state.options = options,
    loadUserInfo: (state, user) => {
      window.localStorage.setItem('user', JSON.stringify(user));
    },
    LOGIN: (state, { token }) => {
      window.localStorage.setItem('token:online-reservation', token);
    },
    LOGOUT: () => {
      window.localStorage.removeItem('user')
      window.localStorage.removeItem('token:online-reservation')
    },
    showLoading: (state, show) => {
      if (show) {
        state.ref.loading.count++;
        state.show.loading = true;
      } else if (state.ref.loading.count > 0) {
        state.ref.loading.count--;
        state.show.loading = (state.ref.loading.count > 0);
      }
    },
    showAlert: (state, { message, code, style, show, messageHtml, closeOnChangeRoute, dismissible = true }) => {
      if (show === undefined) show = DEFAULT_DISMISS_TIME_ALERT;
      state.alert = { message, code, style, show, messageHtml, closeOnChangeRoute, dismissible };
    },
  },
  actions: {
    language({commit}, language){
      if (language) localStorage.setItem('language', JSON.stringify(language));
      else localStorage.removeItem('language');
      commit('language', language);
    },
    showLoading: (context, show) => {
      context.commit("showLoading", show)
    },
    loadUserInfo(context, user) {
      context.commit("loadUserInfo", user);
    },
    login(context, { token }) {
      context.commit("LOGIN", { token })
    },
    logout(context) {
      context.commit("LOGOUT")
    },
    showAlert: (context, { message, code, style, show, messageHtml, closeOnChangeRoute, dismissible }) => {
      context.commit("showAlert", { message, code, style, show, messageHtml, closeOnChangeRoute, dismissible });
    },
    hideAlert: (context) => {
      context.commit("showAlert", { message: '', code: 0, style: '', show: false });
    },
  }
});



// WEBPACK FOOTER //
// ./src/store/store.js